"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAmountBelowCurrencyReasonableLimit = void 0;
const consts_1 = require("../../consts");
const isAmountBelowCurrencyReasonableLimit = (currency, amount) => amount <= consts_1.Currencies[currency].max_allowed_value;
exports.isAmountBelowCurrencyReasonableLimit = isAmountBelowCurrencyReasonableLimit;
